import React, { useEffect } from 'react';
import { Form, FormInstance, SelectBooleanInput } from 'blueprint-form';
import { Row, Col } from '../../../../grid';
import { CardBlock } from '../../../organisms/card';

interface EpxAsthmaYZSettingsData {
  alerts?: boolean;
  alertAfterHour?: boolean;
}

const DefaultSettings: EpxAsthmaYZSettingsData = {
  alerts: true,
  alertAfterHour: true
};

interface EpxAsthmaYZSettingsProps {
  setForm?: (form: FormInstance<EpxAsthmaYZSettingsData>) => void;
  onSubmit?: (data: EpxAsthmaYZSettingsData) => void;
  disabled?: boolean;
}

const EpxAsthmaYZSettings = ({
  setForm,
  onSubmit: _onSubmit,
  disabled
}: EpxAsthmaYZSettingsProps): JSX.Element => {
  const form = new FormInstance<EpxAsthmaYZSettingsData>(DefaultSettings);
  useEffect(() => {
    if (setForm) {
      setForm(form);
    }
  }, []);
  const onChange = (data: EpxAsthmaYZSettingsData): void => {
    form.setData(data);
  };
  const onSubmit = (data: EpxAsthmaYZSettingsData): void => {
    _onSubmit(data);
  };
  return (
    <CardBlock bare>
      <Form form={form} onChange={onChange} onSubmit={onSubmit}>
        <CardBlock>
          <Row>
            <Col sm={24}>
              <SelectBooleanInput
                label="Inform Business Hour"
                name="afterHourInfo"
                fill
                disabled={disabled}
              />
            </Col>
          </Row>
        </CardBlock>
      </Form>
    </CardBlock>
  );
};

export default EpxAsthmaYZSettings;
